import {Component} from "react";
import simplyContext from "../../../../settings/state/simply";
import withRouter from "../../../main/withRouter"
import {Helmet, HelmetProvider} from "react-helmet-async";
import {NavLink} from "react-router-dom";
import {header} from "../../components/header";
import {footer} from "../../components/footer";
import {urlDynamic} from "../../../../settings/utils/urlDynamic";

class AmoozeshSalamat extends Component {
    static contextType = simplyContext

    componentDidMount() {
        this.context.fReset()
        this.context.fPreloader(false)
    }

    render() {
        return (
            <HelmetProvider>
                <Helmet>
                    <title>درسنامه آموزش سلامت</title>
                    <link rel="canonical" href={"https://nasrme.ac.ir/درسنامه-آموزش-سلامت"}/>
                </Helmet>

                <div className='container-fluid cFlex1'>

                    {header(this.context)}


                    <div className='row py-2 cBg7 justify-content-center cPx1 cBrudcRum'>
                        <div className='cContainer col-12'>
                            <div className='row justify-content-center'>
                                <div className='col-12 lh-lg'>
                                    <NavLink to={urlDynamic.path.homeFa}
                                             className='text-white cFontSize13 cHover4 cTransition'>صفحه
                                        اصلی</NavLink>
                                    <span className='mx-1 cFontSize13 text-white'>/</span>
                                    <h1 className='cColor2 d-inline-block cFontSize13'>آموزش سلامت</h1>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='row py-5 position-relative cBg3 justify-content-center cPx1 cFlex2'>
                        <div className='cContainer col-12'>
                            <div className='row cBg4 justify-content-center'>
                                <div className='col-12'>
                                    <div className='row justify-content-center'>
                                        <div className='col-12 col-sm-6 col-lg-3 my-3'>
                                            <div>
                                                <NavLink to="/ساز-و-کار"
                                                         className="cHover7 card position-relative overflow-hidden rounded-0 h-100 rounded rounded-4 border">
                                                    <img src="/images/111.webp" width="445" height='325'
                                                         className="img-fluid"
                                                         alt="تصویر"/>
                                                </NavLink>
                                                <NavLink to="/ساز-و-کار"
                                                         className='text-dark fw-bold d-block text-center mt-2 lh-lg cFontSize12 cTransition'>
                                                    ساز و کارهای آموزشی
                                                </NavLink>
                                            </div>
                                        </div>
                                        <div className='col-12 col-sm-6 col-lg-3 my-3'>
                                            <div>
                                               <NavLink to="/سرفصل"
                                                         className="cHover7 card position-relative overflow-hidden rounded-0 h-100 rounded rounded-4 border">
                                                    <img src="/images/112.webp" width="445" height='325'
                                                         className="img-fluid"
                                                         alt="تصویر"/>
                                                </NavLink>
                                                <NavLink to="/سرفصل"
                                                         className='text-dark fw-bold d-block text-center mt-2 lh-lg cFontSize12 cTransition'>
                                                  سرفصل ها و اهداف آموزشی
                                                </NavLink>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {footer()}


                </div>

            </HelmetProvider>
        )
    }
}

export default withRouter(AmoozeshSalamat)